import dompurify from "dompurify";
import { LoadingStyle } from "pages/comum/Layout/layout.style";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DateHelper from "utils/dateHelper";
import GenericAlert from "../../../components/Alert/genericAlert.component";
import Button from "../../../components/Button/button.component";
import Label from "../../../components/Label/label.component";
import Subtitle from "../../../components/Subtitle/subtitle.component";
import Title from "../../../components/Title/title.component";
import { Creators as DadosParametrizadoActions } from "../../../store/ducks/alertas/dadoParametrizado";

const mapStateToProps = state => ({
	dadoParametrizado: state.dadoParametrizado.dadoParametrizado,
	status: state.dadoParametrizado.status,
	responsavel: state.dadoParametrizado.responsavel,
	dataAcao: state.dadoParametrizado.dataAcao,
	responsavelEmissao: state.dadoParametrizado.responsavelEmissao,
	dataHoraEmissao: state.dadoParametrizado.dataHoraEmissao
});

const mapDispatchToProps = dispatch => ({
	DadosParametrizadoActions: bindActionCreators(
		DadosParametrizadoActions,
		dispatch
	)
});

class CadastroDadosParametrizados extends Component {
	state = {
		loading: false
	};

	componentDidMount() {
		const {
			DadosParametrizadoActions: dadosParametrizadoActions,
			alertaId
		} = this.props;
		this.setLoading(true);
		dadosParametrizadoActions.dadoParametrizadoBuscarPorAlertaId(
			alertaId,
			this.setLoading.bind(this)
		);
	}

	setLoading(loading) {
		this.setState({ loading });
	}

	innerHTMLPurified = text => {
		const textToBeSanitizer = text;
		const sanitizer = dompurify.sanitize;
		// eslint-disable-next-line react/no-danger
		return (
			<span
				dangerouslySetInnerHTML={{
					__html: sanitizer(textToBeSanitizer) || " "
				}}
			/>
		);
	};

	render() {
		const {
			dadoParametrizado: {
				iniciador,
				dataOcorrencia,
				horaOcorrencia,
				periodo,
				categoria,
				severidade,
				urgencia,
				confianca,
				danosPossiveis,
				planoContigencia,
				informacoes,
				alertaStatus
			},
			onClick,
			handleBackButton,
			responsavel,
			dataAcao,
			responsavelEmissao,
			dataHoraEmissao
		} = this.props;

		return (
			<div className="mt-3">
				{this.state.loading && (
					<LoadingStyle className="loading">
						<div className="text-center">
							<div className="spinner-border" role="status" />
						</div>
					</LoadingStyle>
				)}
				{
					<GenericAlert
						type="primary"
						body={
							<div>
								<Subtitle style={{ color: "#134265" }}>
									Informações sobre o alerta
								</Subtitle>
								<div
									className="row"
									style={{ paddingTop: "15px" }}
								>
									<Label
										label="Status"
										text={
											((alertaStatus || {}).status || {})
												.nome || " ---"
										}
										col={4}
									/>

									<Label
										label={
											((alertaStatus || {}).status || {})
												.nome === "Ativo"
												? "Data/Hora da emissão"
												: "Data/Hora"
										}
										text={
											((alertaStatus || {}).status || {})
												.nome === "Ativo"
												? dataHoraEmissao
												: dataAcao
										}
										col={4}
									/>

									<Label
										label="Responsável"
										text={
											((alertaStatus || {}).status || {})
												.nome === "Ativo"
												? responsavelEmissao
												: responsavel
										}
										col={4}
									/>
								</div>
								{(((alertaStatus || {}).status || {}).nome ===
									"Cessado" ||
									((alertaStatus || {}).status || {}).nome ===
										"Cancelado") && (
									<div className="row">
										<Label
											label="Mensagem"
											text={this.innerHTMLPurified(
												(alertaStatus || {}).mensagem ||
													" ---"
											)}
										/>
									</div>
								)}
							</div>
						}
					/>
				}

				<Title> Dados parametrizados do possível alerta</Title>
				<hr />

				<div>
					<div className="mb-2">
						<div className="row">
							<Label
								label="Origem da informação"
								text={(iniciador || {}).nome || " --- "}
								col={6}
								colLabel={6}
							/>
							<Label
								label="Data da informação"
								text={DateHelper.formatDate(dataOcorrencia)}
								col={6}
								colLabel={6}
							/>
						</div>

						<div className="row">
							<Label
								label="Hora da informação"
								text={
									(horaOcorrencia || "").substring(5, 0) ||
									" --:-- "
								}
								col={6}
								colLabel={6}
							/>
						</div>
					</div>

					<Subtitle>Evento</Subtitle>
					<hr />
					<div className="mb-3">
						<div className="row">
							<Label
								label="Categoria do evento"
								text={(categoria || {}).nome || " --- "}
								col={6}
								colLabel={6}
							/>
							<Label
								label="Severidade do evento"
								text={(severidade || {}).nome || " --- "}
								col={6}
								colLabel={6}
							/>
						</div>

						<div className="row">
							<Label
								label="Urgência"
								text={(urgencia || {}).nome || " --- "}
								col={6}
								colLabel={6}
							/>
							<Label
								label="Confiança"
								text={(confianca || {}).nome || " --- "}
								col={6}
								colLabel={6}
							/>
						</div>
						<div className="row">
							<Label
								label="Duração do evento (em horas)"
								text={periodo || " --:-- "}
								col={6}
								colLabel={6}
							/>
						</div>
					</div>

					<Subtitle>Informações</Subtitle>
					<hr />
					<div className="row">
						<Label
							label="Danos possíveis"
							text={danosPossiveis || " --- "}
							col={6}
							colLabel={6}
						/>
						<Label
							label="Recomendações de segurança"
							text={planoContigencia || " --- "}
							col={6}
							colLabel={6}
						/>
					</div>

					<div className="row">
						<Label
							label="Informações recebidas da origem"
							text={informacoes || " --- "}
							col={6}
							colLabel={6}
						/>
					</div>
					<div className="row">
						<div className="col-md-6">
							<div className="float-left">
								<Button
									type="button"
									cancel
									text="Sair"
									icon="fas fa-times"
									onClick={() => handleBackButton()}
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="float-right">
								<Button
									onClick={() => onClick("geo")}
									type="submit"
									primary
									text="Próximo"
									icon="fas fa-arrow-right"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CadastroDadosParametrizados);
